module.exports = "<md-dialog flex> <md-toolbar> <div flex layout=row class=md-toolbar-tools layout-align=\"space-around center\"> <div flex class=preview-heading> <p style=margin-bottom:0!important;font-size:20px>Image Preview</p> </div> <i class=\"fas fa-times\" style=display:flex ng-click=cancel()></i> </div> </md-toolbar> <md-divider></md-divider> <md-dialog-content> <div class=md-dialog-content layout=column style=background:#fff;text-align:center> <div> <img src={{imageDetails.image}} style=height:300px> </div> </div> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/traditionalActivity/views/imageViewPopup.html
// module id = 929
// module chunks = 462